import moment, { Moment } from 'moment';

export const overlaps = (a: Array<Moment>, b: Array<Moment>): boolean => {
  return moment(a[0]).isAfter(moment(b[0])) &&
    moment(a[0]).isBefore(moment(b[1])) || moment(a[1]).isAfter(moment(b[0])) && moment(a[1]).isBefore(moment(b[1]))
}